import React from 'react';
import Box from '@mui/material/Box';
import RemediationBox from '../../NRRemediation/RemediationBox';
import { REMEDIATION_CONSTANTS } from '../../NRRemediation/NRRemediation.constants';

function NRSecretRemediationStepOne() {
  return (
    <Box my={5}>
      <RemediationBox
        title={REMEDIATION_CONSTANTS.STATUS.LABELS.UNREVIEWED}
        optValue={REMEDIATION_CONSTANTS.STATUS.VALUES.UNREVIEWED}
        showAlert={false}
      />
      <RemediationBox title={REMEDIATION_CONSTANTS.STATUS.LABELS.EXPOSED} optValue={REMEDIATION_CONSTANTS.STATUS.VALUES.EXPOSED} showAlert={false} />
      <RemediationBox title={REMEDIATION_CONSTANTS.STATUS.LABELS.REMOVED} optValue={REMEDIATION_CONSTANTS.STATUS.VALUES.REMOVED} showAlert={false} />
      <RemediationBox
        title={REMEDIATION_CONSTANTS.STATUS.LABELS.FALSE_POSITIVE}
        optValue={REMEDIATION_CONSTANTS.STATUS.VALUES.FALSE_POSITIVE}
        showAlert={false}
      />
      <RemediationBox
        title={REMEDIATION_CONSTANTS.STATUS.LABELS.COMPENSATING_CONTROLS}
        optValue={REMEDIATION_CONSTANTS.STATUS.VALUES.COMPENSATING_CONTROLS}
        showAlert={false}
      />
    </Box>
  );
}

export default NRSecretRemediationStepOne;
